<script>
    import {derived} from 'svelte/store';

    import {offlineDatabases} from "../../Database.svelte";
    import Assessment from '../../Models/assessmentModel';
    import SyncStatus from '../Assessment/SyncStatus.svelte';
    import Loader from '../Loader.svelte';
    import {confirm} from '../Confirmation.svelte';

    let assessments = Assessment.getAssessmentList();

    let assessmentsByKeys = derived([assessments], ([$assessments], set) => {
        if (!$assessments) return;

        let assessment_map = {};
        for (let assessment of $assessments) {
            assessment_map[`${assessment.assessment_db}`] = assessment;
        }

        console.log(assessment_map)
        set(assessment_map);
    });

    function stopSync(assessment_db) {
        if ($offlineDatabases[assessment_db].syncStatus != 0) {
            confirm("Assessment Sync is not complete, unsynced changes may be lost. Are you sure?").then(() => {
                Assessment.stopSync({assessment_db})
            })
        } else {
            Assessment.stopSync({assessment_db})
        }
    }
</script>

<Loader loading={!$assessmentsByKeys}>
    <div class="container is-fluid">
        <div class="columns">
            <div class="column">
                <h2 class="title is-3">Manage Sync</h2>

                <table class="table is-striped">
                    <thead>
                        <tr>
                            <th>Assessment</th>
                            <th>Sync Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each Object.keys($offlineDatabases) as key}
                            {@const assessment = $assessmentsByKeys[key]}
                            <tr>
                                <td>
                                    {#if assessment}
                                        {assessment.name}
                                    {:else}
                                        {key}
                                    {/if}
                                </td>
                                <td><SyncStatus value={key}></SyncStatus></td>
                                <td>
                                    <span class="button is-info" on:click={() => stopSync(key)}>Stop Sync</span>
                                    {#if assessment}
                                        <a class="button is-primary" href="#/assessment/{assessment._id}">Open Assessment</a>
                                    {/if}
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</Loader>